import { isEqual } from 'bold-ui'
import { isEmpty } from 'util/validation/Util'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  filterDefaultAcompanhamentoCondicaoSaude,
} from './model/model-acompanhamentoCondicaoSaude'

export function isFilterEqualDefault(filter: AcompanhamentoCondicaoSaudeFormModel) {
  const filterDefault = filterDefaultAcompanhamentoCondicaoSaude[filter.listaTematica]
  return isEqual(
    {
      periodoUltimoAtendimento: filter?.periodoUltimoAtendimento ?? null,
      grupoCondicao: !isEmpty(filter?.grupoCondicao) ? filter?.grupoCondicao : null,
      problemasCondicoes: !isEmpty(filter?.problemasCondicoes) ? filter?.problemasCondicoes : null,
      ativoListaProblema: filter?.ativoListaProblema || null,
      sexo: !isEmpty(filter?.sexo) ? filter?.sexo : null,
      tipoFaixaEtaria: filter?.tipoFaixaEtaria ?? null,
      faixaEtariaRange: filter?.faixaEtariaRange ?? null,
      identidadeGenero: !isEmpty(filter?.identidadeGenero) ? filter?.identidadeGenero : null,
      ivcf: filter?.ivcf ?? undefined,
    },
    {
      periodoUltimoAtendimento: filterDefault?.periodoUltimoAtendimento,
      grupoCondicao: filterDefault?.grupoCondicao,
      problemasCondicoes: filterDefault?.problemasCondicoes,
      ativoListaProblema: filterDefault?.ativoListaProblema,
      sexo: filterDefault?.sexo,
      tipoFaixaEtaria: filterDefault?.tipoFaixaEtaria,
      faixaEtariaRange: filterDefault?.faixaEtariaRange,
      identidadeGenero: filterDefault?.identidadeGenero,
      ivcf: filterDefault?.ivcf,
    }
  )
}
